import React from 'react';
import { Chip } from '@mui/material';

interface StatusChipProps {
  statusId: number;
  statuses?: any[];
}

export const StatusChip: React.FC<StatusChipProps> = ({ 
  statusId,
  statuses = [] 
}) => {
  // DEBUG: Gelen değerleri kontrol edelim
  console.log('StatusChip - statusId:', statusId, 'statuses:', statuses);

  // statuses array'inden status ismini bul
  const getStatusName = () => {
    if (!statusId) return 'Bilinmeyen';
    
    const foundStatus = statuses.find(s => s.id === statusId);
    return foundStatus?.name || `Durum ${statusId}`;
  };

  const statusName = getStatusName();

  // Status ismine göre config
  const statusConfig: { [key: number]: any } = {
    1: { icon: '🆕', label: 'Yeni' },
    2: { icon: '👤', label: 'Atandı' },
    3: { icon: '🚀', label: 'Başlandı' },
    4: { icon: '🧪', label: 'Test' },
    5: { icon: '↩️', label: 'Testten Döndü' },
    6: { icon: '✅', label: 'Tamamlandı' },
    7: { icon: '⏳', label: 'Bekliyor' },
    8: { icon: '🔒', label: 'Kapandı' },
  };

  const config = statusConfig[statusId] || { icon: '❓', label: statusName };
  
  return (
    <Chip 
      label={`${config.icon} ${config.label}`} 
      size="small" 
      variant="outlined"
      sx={{ 
        borderColor: 'grey.400',
        borderWidth: '1.5px',
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        height: '24px', // ✅ Yükseklik küçültüldü
        '& .MuiChip-label': { 
          px: 0.8, // ✅ Padding küçültüldü
          fontSize: '0.75rem' // ✅ Font küçültüldü
        },
        minWidth: '105px', // ✅ Min width küçültüldü
        maxWidth: '105px', // ✅ Max width küçültüldü
        fontWeight: 'medium'
      }}
    />
  );
};